
import React from 'react';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { CategoryIcon } from '../../shared/CategoryIcon';
import { TopicType } from '@/types/assistant';
import { TOPIC_CONFIG } from '@/contexts/AiAssistantContext';
import { cn } from '@/lib/utils';
import { motion } from 'framer-motion';

interface SidebarFiltersProps {
  activeTopic: TopicType | null;
  onTopicClick: (topic: TopicType | null) => void;
}

export const SidebarFilters: React.FC<SidebarFiltersProps> = ({
  activeTopic,
  onTopicClick
}) => {
  return (
    <div className="flex gap-1">
      <Button
        variant={activeTopic === null ? "default" : "outline"}
        size="sm"
        className={cn(
          "text-xs flex-grow",
          activeTopic === null ? "bg-primary/90 hover:bg-primary shadow-md shadow-primary/20" : "bg-background/30 border-white/10"
        )}
        onClick={() => onTopicClick(null)}
      >
        All
      </Button>
      {Object.entries(TOPIC_CONFIG).map(([key, config]) => (
        <Tooltip key={key}>
          <TooltipTrigger asChild>
            <Button
              variant={activeTopic === key ? "default" : "outline"}
              size="sm"
              className={cn(
                "px-2",
                activeTopic === key 
                  ? `${config.bgColor} ${config.color} hover:${config.bgColor} border ${config.borderColor} shadow-md shadow-${config.color}/10` 
                  : "hover:bg-white/10 bg-background/30 border-white/10"
              )}
              onClick={() => onTopicClick(key as TopicType)}
            >
              <CategoryIcon 
                category={key as TopicType} 
                className={activeTopic === key ? config.color : "text-foreground"} 
              />
            </Button>
          </TooltipTrigger>
          <TooltipContent side="bottom" className="bg-background/80 backdrop-blur-md border-white/20">
            {config.label}
          </TooltipContent>
        </Tooltip>
      ))}
    </div>
  );
};
